export default function TwitterXLogo(props: React.ComponentProps<"svg">) {
    return (
        <svg
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g opacity="0.7" clipPath="url(#clip0_1173_3306)">
                <path
                    d="M10.7142 10.3774L17.4162 18H15.8286L10.0068 11.3827L5.3604 18H0L7.0278 7.99254L0 0H1.5876L7.7316 6.98958L12.6396 0H18M2.1606 16.8286H4.5996L15.8274 1.11387H13.3878"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_1173_3306">
                    <rect
                        width="18"
                        height="18"
                        fill="currentColor"
                        transform="matrix(1 0 0 -1 0 18)"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}
